import { supabase } from './supabaseClient';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

async function authHeaders() {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  const base = token ? { Authorization: `Bearer ${token}` } : {};
  try {
    const ts = window.localStorage.getItem('sp.iapPurchased.v1');
    if (ts) {
      const age = Date.now() - Number(ts);
      if (age >= 0 && age <= 30 * 60 * 1000) {
        base['X-IAP-Recent'] = String(ts);
      }
    }
  } catch { /* localStorage disabled */ }
  return base;
}

async function call(path, opts = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...(await authHeaders()),
    ...(opts.headers || {}),
  };
  const res = await fetch(`${BACKEND}/api${path}`, { ...opts, headers });
  if (!res.ok) {
    let detail = res.statusText;
    try {
      const j = await res.json();
      detail = j.detail || detail;
    } catch (e) {
      // ignore
    }
    throw new Error(detail);
  }
  return res.json();
}

export const teamApi = {
  info: () => call('/team/info'),
  invite: (email) =>
    call('/team/invite', {
      method: 'POST',
      body: JSON.stringify({ email, origin: window.location.origin }),
    }),
  resend: (memberId) =>
    call(`/team/resend/${memberId}`, { method: 'POST' }),
  accept: (token) =>
    call('/team/accept', {
      method: 'POST',
      body: JSON.stringify({ token }),
    }),
  lookupInvitation: (token) => call(`/team/invitation/${encodeURIComponent(token)}`),
  remove: (memberId) =>
    call(`/team/members/${memberId}`, { method: 'DELETE' }),
  leave: () => call('/team/leave', { method: 'POST' }),
};
